import { Checkbox, FormLabel } from '@chakra-ui/react';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { useCheckoutSFRViewModel } from '../../../models/CheckoutSFRViewModel';

type AgreementProps = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Agreement: React.FC<AgreementProps> = ({ onChange }) => {
  const model = useCheckoutSFRViewModel();
  return (
    <FormLabel alignItems={'flex-start'} gap="20px" display={'flex'} flexDirection="row" cursor={'pointer'}>
      <Checkbox isChecked={model.amountAgreement} onChange={onChange} iconSize={'30px'} size="lg" mt={'4px'}></Checkbox>
      <TextBlock fontSize="16px" color="blackAlpha.700">
        I understand that my investment cannot be refunded and generally has a hold period of 5 years or more.
      </TextBlock>
    </FormLabel>
  );
};
